import React, { useEffect, useTransition } from "react";
import Context from "../../../../../context";

import {
  CustomModal,
  CustomView,
  UserInformation,
} from "../../../../../components";
import {
  ICityItem,
  IProvinceItem,
} from "../../../../../types/common.interface";
import { useQuery } from "react-query";
import api from "../../../../../api";
import values from "../../../../../values";
import { useTranslation } from "react-i18next";

const CompanyInformation = () => {
  const { showModal, setShowModal, selectedDriver } = React.useContext(
    Context.DriverScreen
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedCity, setSelectedCity] = React.useState<ICityItem>();
  const [selectedProvince, setSelectedProvince] =
    React.useState<IProvinceItem>();

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );
  const getAllCity = useQuery(
    [values.useQueryKeys.getAllCity, selectedProvince],
    () =>
      api.get.common.getAllCity({
        provinceCode: selectedProvince
          ? selectedProvince?.Code
          : getAllProvince?.data?.result?.find(
              (item: IProvinceItem) =>
                item?._id === selectedDriver?.schoolDriverInformation?.province
            ).Code,
      })
  );

  useEffect(() => {
    setSelectedProvince(
      getAllProvince?.data?.result?.find(
        (item: IProvinceItem) =>
          item?._id === selectedDriver?.schoolDriverInformation?.province
      )
    );
    setSelectedCity(
      getAllCity?.data?.result?.find(
        (item: ICityItem) =>
          item?._id === selectedDriver?.schoolDriverInformation?.city
      )
    );
  }, [selectedDriver, getAllProvince?.data?.result, getAllCity?.data?.result]);

  const { t } = useTranslation();

  return (
    <section id="service-screen-show-user-information">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        minWidth={"30vw"}
        maxWidth={"50vw"}
        open={showModal === "SHOW_COMPANY_INFORMATION"}
        overlayClose
      >
        <CustomView.Container className="scroll-content">
          <UserInformation
            avatar={undefined}
            name={selectedDriver?.schoolDriverInformation?.companyName}
            isBlock={null}
          />
          <hr />
          <CustomView.Row className="form-column-row">
            {selectedDriver?.companyInformation?.approved && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("status")} :</label>
                <p>
                  {selectedDriver?.companyInformation?.approved?.isApproved
                    ? t("approved")
                    : t("disApproved")}
                </p>
              </CustomView.Column>
            )}
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default CompanyInformation;
